export function ownerId(entity) {
    const id = entity?.user_id ?? entity?.user?.id;
    return id === undefined || id === null ? "" : String(id);
}

export function isOwnedBy(entity, user) {
    const entityOwnerId = ownerId(entity);
    const currentUserId = user?.id;
    return Boolean(
        entityOwnerId &&
        currentUserId !== undefined &&
        currentUserId !== null &&
        entityOwnerId === String(currentUserId)
    );
}
